import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

export const EFFECT_TYPE_LABELS = {
  document: "Dokument",
  mail: "Mail",
  notification: "Benachrichtigung",
  communication: "Kommunikation",
};

export const SEND_TO_LABELS = {
  kunde: "Kunde",
  mitarbeiter: "Mitarbeiter",
  versicherer: "Versicherer",
};

export const EFFECT_ICONS = {
  document: PictureAsPdfIcon,
  mail: MailOutlineIcon,
  notification: NotificationsActiveOutlinedIcon,
  communication: ForumOutlinedIcon,
};

// Phasen des Workflows, im Diagramm als Rahmen um ihre Status. Nicht aufgeführte
// Status stehen ohne Rahmen im Diagramm.
export const PHASES = [
  {
    id: "erfassung",
    label: "Erfassung",
    states: ["saved", "customer_pre_check"],
  },
  {
    id: "pruefung",
    label: "Prüfung",
    states: ["pre_check", "correction_customer"],
  },
  {
    id: "versicherer",
    label: "Bearbeitung Versicherer",
    states: ["processing", "processed", "correction_insurer"],
  },
  {
    id: "regulierung",
    label: "Regulierung",
    states: ["released", "partial_settled", "settled"],
  },
  {
    id: "abgeschlossen",
    label: "Abgeschlossen",
    states: [
      "closed",
      "closed_below_threshold",
      "closed_not_insured",
      "rejected",
    ],
  },
];
